// extracted by mini-css-extract-plugin
export default {"root":"Closing_root__nrUnF"};